import CandidateDetails from "./candidateDetails";
export default CandidateDetails;